import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter,} from '@angular/material-moment-adapter';
import {UntypedFormControl} from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import {TextKeys} from '../../core/i18n/text-keys';
import {DateRange} from '../../core/models/date-range';
import {TIMEZONE} from '../../core/services/language.service';

const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-year-selection',
  templateUrl: './year-selection.component.html',
  styleUrls: ['./year-selection.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
  ],
})
export class YearSelectionComponent implements OnInit, OnDestroy {

  @Input() defaultDate: DateRange;
  @Output() yearSelectionChanged = new EventEmitter<string>();

  date: UntypedFormControl;
  texts = TextKeys;

  constructor() {
  }

  ngOnInit() {
    if (this.defaultDate) {
      this.date = new UntypedFormControl(moment.tz(this.defaultDate.end, TIMEZONE))
    } else {
      this.date = new UntypedFormControl(moment.tz(moment(), TIMEZONE))
    }
  }

  ngOnDestroy(): void {
  }

  onChange(): void {
    this.yearSelectionChanged.emit(this.getYear());
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.onChange();
  }

  getYear(): string {
    return this.date.value.year();
  }

  disable() {
    this.date.disable();
  }

  enable() {
    this.date.enable();
  }

  previousYear(event: Event) {
    event.stopImmediatePropagation();
    this.date.setValue(moment.tz(moment(), TIMEZONE).year(this.date.value.year() - 1));
    this.onChange();
  }

  nextYear(event: Event) {
    event.stopImmediatePropagation();
    this.date.setValue(moment.tz(moment(), TIMEZONE).year(this.date.value.year() + 1));
    this.onChange();
  }


}
